import React, { useEffect, useRef } from "react";
import { App } from "../../three/App";
import Emitter from "../../helpers/emitters";

export const View360 = () => {
	const gameContainer = useRef(null);
	const active = useRef(null);

	useEffect(() => {
		if (!active.current) {
			const app = new App(gameContainer.current);
			active.current = true;
			window.addEventListener("resize", () => {
				app.onResize();
			});

			window.addEventListener("mousedown", (event) => {
				Emitter.emit("dragAndDrop", 0);
			});
			window.addEventListener("mouseup", (event) => {
				Emitter.emit("raycaster", event);
			});
			// window.addEventListener("click", (event) => {
			// 	console.log("click");
			// 	// Emitter.emit("raycaster", event);
			// });
			window.addEventListener("mousemove", (event) => {
				Emitter.emit("raycasterMouseMove", event);
			});
		}
	}, []);

	return (
		<>
			<div ref={gameContainer} className="h-screen w-full"></div>
		</>
	);
};
